var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantiplyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "30px",
    viewBox: "0 0 29 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results",
    transform: "translate(-29.000000, -17.000000)",
    strokeWidth: 4.19731981
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(30.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 0.864000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.192,
    y1: 25.704,
    x2: 13.6512,
    y2: 25.704,
    id: "Line-2-Copy",
    stroke: "#456FEB",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.4352,
    y1: 13.824,
    x2: 13.4352,
    y2: 23.2220688,
    id: "Line-2-Copy-2",
    stroke: "#456FEB",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57919594,4.32 L21.2048041,4.32 C21.9002388,4.32 22.464,4.88376123 22.464,5.57919594 L22.464,21.2048041 C22.464,21.9002388 21.9002388,22.464 21.2048041,22.464 L5.57919594,22.464 C4.88376123,22.464 4.32,21.9002388 4.32,21.2048041 L4.32,5.57919594 C4.32,4.88376123 4.88376123,4.32 5.57919594,4.32 Z",
    id: "Rectangle-Copy",
    stroke: "#2A55D5",
    transform: "translate(13.392000, 13.392000) rotate(-45.000000) translate(-13.392000, -13.392000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57919594,4.32 L21.2048041,4.32 C21.9002388,4.32 22.464,4.88376123 22.464,5.57919594 L22.464,21.2048041 C22.464,21.9002388 21.9002388,22.464 21.2048041,22.464 L5.57919594,22.464 C4.88376123,22.464 4.32,21.9002388 4.32,21.2048041 L4.32,5.57919594 C4.32,4.88376123 4.88376123,4.32 5.57919594,4.32 Z",
    id: "Rectangle-Copy-2",
    stroke: "#2A55D5",
    transform: "translate(13.392000, 13.392000) rotate(-45.000000) translate(-13.392000, -13.392000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantiplyLogo);
export default __webpack_public_path__ + "static/media/quantiply-logo.9b98b685b0605c25a00df866f5e3f3d9.svg";
export { ForwardRef as ReactComponent };